export class HttpRequest {
    method: string;
    uri: string;
    body: string;
    headers: string;
    server: string;
}
